var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4193 25.0391H3.41927C2.68289 25.0391 2.08594 25.636 2.08594 26.3724V30.3724C2.08594 31.1088 2.68289 31.7057 3.41927 31.7057H13.4193C14.1557 31.7057 14.7526 31.1088 14.7526 30.3724V26.3724C14.7526 25.636 14.1557 25.0391 13.4193 25.0391Z",
    fill: "#E7EBF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.4193 25.5391H3.41927C2.95903 25.5391 2.58594 25.9122 2.58594 26.3724V30.3724C2.58594 30.8326 2.95903 31.2057 3.41927 31.2057H13.4193C13.8795 31.2057 14.2526 30.8326 14.2526 30.3724V26.3724C14.2526 25.9122 13.8795 25.5391 13.4193 25.5391Z",
    stroke: "#5B616B",
    strokeWidth: 1.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union 1",
    d: "M4.62329 25.5381C4.62329 25.5381 1.25862 18.2961 0.97662 17.1595C0.814958 16.242 0.743506 15.3109 0.763286 14.3795C0.755845 14.3218 0.752059 14.2636 0.751953 14.2055L0.751953 5.44479C0.751953 5.08233 0.895941 4.73471 1.15224 4.47841C1.40854 4.22211 1.75616 4.07812 2.11862 4.07812C2.48108 4.07812 2.8287 4.22211 3.085 4.47841C3.3413 4.73471 3.48529 5.08233 3.48529 5.44479V13.6395C3.52062 13.7655 3.55995 13.9115 3.60462 14.0795C4.00062 15.5561 5.84862 17.3415 6.91795 18.3388C5.93614 17.3359 5.00753 16.2822 4.13595 15.1821C4.13595 14.9981 4.05262 13.0748 5.78062 13.0748C7.50862 13.0748 8.66595 14.4141 10.1093 15.9735C11.5526 17.5328 11.818 18.3221 12.0426 19.3575C12.2673 20.3928 12.0426 25.5381 12.0426 25.5381H4.62329Z",
    stroke: "#5B616B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 305_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.0827 25.0391H18.7493C18.013 25.0391 17.416 25.636 17.416 26.3724V30.3724C17.416 31.1088 18.013 31.7057 18.7493 31.7057H28.0827C28.8191 31.7057 29.416 31.1088 29.416 30.3724V26.3724C29.416 25.636 28.8191 25.0391 28.0827 25.0391Z",
    fill: "#E7EBF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.0827 25.5391H18.7493C18.2891 25.5391 17.916 25.9122 17.916 26.3724V30.3724C17.916 30.8326 18.2891 31.2057 18.7493 31.2057H28.0827C28.5429 31.2057 28.916 30.8326 28.916 30.3724V26.3724C28.916 25.9122 28.5429 25.5391 28.0827 25.5391Z",
    stroke: "#5B616B",
    strokeWidth: 1.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union 1_2",
    d: "M31.0801 5.44391L31.0801 14.2059C31.0802 14.2641 31.0766 14.3222 31.0694 14.3799C31.0892 15.3111 31.0177 16.242 30.8561 17.1592C30.5734 18.2959 27.0681 25.5039 27.0681 25.5039H19.6681C19.6681 25.5039 19.5594 20.3932 19.7861 19.3572C20.0127 18.3212 20.2787 17.5326 21.7194 15.9732C23.1601 14.4139 24.3221 13.0726 26.0507 13.0726C27.7794 13.0726 27.6954 14.9959 27.6954 15.1799C26.8244 16.2809 25.8962 17.3355 24.9147 18.3392C25.9814 17.3392 27.8314 15.5579 28.2267 14.0812C28.2714 13.9132 28.3107 13.7672 28.3461 13.6412L28.3461 5.44391C28.3461 5.08144 28.4901 4.73383 28.7464 4.47753C29.0027 4.22123 29.3503 4.07724 29.7127 4.07724C30.0752 4.07724 30.4228 4.22123 30.6791 4.47753C30.9354 4.73383 31.0794 5.08144 31.0794 5.44391H31.0801Z",
    stroke: "#5B616B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtraction 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.4707 8.98207C7.61392 6.86285 8.5115 4.8903 10.0344 3.37417C11.7014 1.71469 13.918 0.800781 16.2759 0.800781C18.6339 0.800781 20.8505 1.71469 22.5174 3.37417C24.0403 4.8902 24.9378 6.86275 25.0812 8.98181C24.3084 8.10709 23.1828 7.58705 21.9919 7.58705C20.839 7.58705 19.7551 8.065 18.9835 8.89092C18.2123 8.06493 17.1286 7.58705 15.9754 7.58705C14.9742 7.58705 14.0128 7.95149 13.2679 8.60101C12.5226 7.95147 11.5613 7.58705 10.5605 7.58705C9.36941 7.58705 8.24362 8.10714 7.4707 8.98207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.9824 8.19902C19.8089 7.48932 20.8708 7.08705 21.9907 7.08705C22.8535 7.08705 23.6858 7.33047 24.4005 7.76742C24.0608 6.24923 23.2952 4.8552 22.1635 3.72852C20.5909 2.16297 18.4996 1.30078 16.2747 1.30078C14.0499 1.30078 11.9586 2.16297 10.386 3.72851C9.25417 4.85529 8.48863 6.24932 8.1489 7.76767C8.86381 7.33064 9.69636 7.08705 10.5593 7.08705C11.5394 7.08705 12.4859 7.39884 13.2666 7.96307C14.0472 7.39882 14.9937 7.08705 15.9742 7.08705C17.0943 7.08705 18.1562 7.48932 18.9824 8.19902ZM7.43189 9.88459L6.95409 9.88429C6.95061 9.76761 6.94922 9.66978 6.94922 9.58457C6.94922 7.10464 7.91921 4.77323 9.68049 3.01983C11.4418 1.26643 13.7837 0.300781 16.2747 0.300781C18.7658 0.300781 21.1077 1.26643 22.869 3.01983C24.6303 4.77323 25.6003 7.10464 25.6003 9.58457C25.6003 9.68427 25.5986 9.78491 25.5954 9.88371L25.1176 9.88429C24.4735 8.7756 23.2756 8.08705 21.9907 8.08705C20.7792 8.08705 19.6545 8.68758 18.9822 9.69347C18.3105 8.68758 17.1864 8.08705 15.9742 8.08705C14.9388 8.08705 13.952 8.53051 13.2668 9.30372C12.581 8.53051 11.5945 8.08705 10.5593 8.08705C9.27447 8.08705 8.076 8.77602 7.43189 9.88459Z",
    fill: "#5B616B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 230",
    d: "M13.6779 8.29362C13.6779 8.29362 13.6111 1.01828 16.0584 0.988281C17.2224 1.00761 17.8203 2.15509 18.1616 3.55176C18.4078 5.17492 18.534 6.81402 18.5386 8.45573C17.8175 7.92566 16.9529 7.62567 16.0584 7.59505C15.215 7.59964 14.3901 7.84169 13.6779 8.29362Z",
    fill: "#E7EBF0",
    stroke: "#5B616B",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 170",
    d: "M16.4512 8.08203V15.3007",
    stroke: "#5B616B",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 231",
    d: "M16.4714 15.0781C16.4583 15.4562 16.2983 15.8143 16.0251 16.0758C15.7518 16.3374 15.387 16.4817 15.0088 16.4782C13.6168 16.4782 13.7474 15.3037 13.7474 15.3037",
    stroke: "#5B616B",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProduct);
export default __webpack_public_path__ + "static/media/default-product.3b562b13cd513572b477648e954e48bd.svg";
export { ForwardRef as ReactComponent };